// import { SelectChangeEvent } from '@mui/material';
import { TypographyTypeMap } from '@mui/material/Typography';
import { ReactElement, ReactNode } from 'react';
import { Badge, Stack, Typography } from '@legacy/components/mui-components';
// import { Select } from '@legacy/components/ui-components/Select';

interface WidgetHeaderProps {
  heading: string;
  widgetKey: string;
  headingAs?: TypographyTypeMap['props']['variant'];
  icon?: ReactElement;
  count?: number;
  action?: ReactNode;
}

export const WidgetHeader = ({
  heading,
  headingAs = 'h4',
  icon,
  count = 0,
  action,
  widgetKey,
  ...props
}: WidgetHeaderProps) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    flexWrap="wrap"
    {...props}
  >
    <Stack direction="row" alignItems="center">
      {count > 0 && icon && (
        <Badge badgeContent={count} color="warning">
          {icon}
        </Badge>
      )}
      {!count && icon && icon}
      <Typography
        component="h2"
        fontWeight={600}
        variant={headingAs}
        data-automation-id={`WidgetHeaderHeading${widgetKey}`}
        sx={{ textAlign: 'center' }}
      >
        {heading}
      </Typography>
    </Stack>

    {action && action}
  </Stack>
);
